<template>
  <div>
    <v-card class="semiborder_1 primary rounded-0">
      <div class="encabezado">
        <h2>
          <v-icon size="32" color="white" @click="toggleMobile = !toggleMobile"
            >menu</v-icon
          >
          <span class="pl-2 white--text">Sistema de Prácticas</span>
        </h2>
        <p class="subtitulo white--text">Departamento de Informática USM</p>
      </div>
    </v-card>
    <div class="wrapper">
      <transition name="slide">
        <v-card
          class="semiborder_2 rounded-0"
          color="primary"
          v-if="toggleMobile"
          height="100%"
        >
          <v-list
            nav
            shaped
            style="padding-left:20px !important;"
            color="primary"
          >
            <v-list-item
              v-for="seccion in menu"
              :key="seccion.to"
              :to="seccion.to"
              :class="{ 'v-list-item--active list_selected': seccion.to === activa }"
              @click="toggleMobile = false"
            >
              <v-list-item-icon
                style="padding-left:20px !important; margin-right:20px !important "
              >
                <v-icon color="white">{{ seccion.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="font-weight-bold white--text">{{
                  seccion.title
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              v-for="(item, index) in sessionItems"
              :key="index"
              @click="actions(item.action)"
            >
              <v-list-item-title class="font-weight-bold white--text">{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </transition>
    </div>
    <ActionModal
      :active="aboutModal"
      title="Sistema de Prácticas"
      :successAction="() => (aboutModal = false)"
      :backDisabled="true"
      :cancelAction="() => (aboutModal = false)"
    >
      Creado por Bastián Quezada Muñoz <a href="https://www.linkedin.com/in/basquezada/"> https://www.linkedin.com/in/basquezada/</a>
<br><br><br>
      <a href="https://storyset.com/">Illustration by Freepik Storyset</a>
    </ActionModal>
  </div>
</template>

<script>
import ActionModal from '../../components/ActionModal.vue'
import { MENU_ADMIN, MENU_ALUMNO, seccionActiva } from './menu';
// import LogoDINavBar from '@/components/icons/logoDINavBar.vue';

export default {
  components: {
    /*LogoDINavBar, */ActionModal
  },
  data: () => ({
    aboutModal: false,
    toggleMobile: false,
    sessionItems: [
      { title: "Cerrar Sesión", action: "0" },
      
      { title: localStorage.getItem("theme") == "true"? "Usar tema oscuro": "Usar tema claro", action: "1" },
      { title: "Acerca del sistema", action: "3" },
    ],
  }),
  computed: {

    drawer: {
      
      get() {
        return this.$store.state.drawer;
      },
      set(state) {
        if (state !== this.$store.state.drawer) {
          this.$store.dispatch("drawer");
        }
      },
    },
    current_user() {
      return this.$store.state.authentication.user;
    },

    is_admin() {
      return this.$store.state.authentication.user.is_staff;
    },

    menu() {
      return this.is_admin ? MENU_ADMIN : MENU_ALUMNO;
    },

    activa() {
      return seccionActiva(this.menu, this.$route.path);
    },
  },
  methods: {
    // change_drawer() {
    //   this.$store.dispatch("drawer");
    // },
    // sizecard(drawer) {
    //   if (drawer) {
    //     return 9;
    //   } else {
    //     return 12;
    //   }
    // },
    actions(id) {
      if (id == "0") {
        if(!this.is_admin){
          this.$keycloak.logout()
        }
        this.$store.dispatch("authentication/logout");
        
      } else if (id == "1") {
        if (localStorage.getItem("theme") == "true") {
          localStorage.setItem("theme", "false");
          this.$vuetify.theme.dark = false;
          this.$router.go();

        } else {
          localStorage.setItem("theme", "true");
          this.$vuetify.theme.dark = true;
          this.$router.go();
        }
      } else {
        this.aboutModal = true
      }
    },
  },
};
</script>

<style scoped>

.card-actions {
  position: absolute;
  bottom: 0;
}

v-list-item--active:hover::before,
.v-list-item--active::before {
  opacity: 0 !important;
}

.wrapper {
  overflow: hidden;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

.semiborder {
  height: 100%;
}

/* Margen propio: los v-container del contenido se compactan en celulares. */
.encabezado {
  padding: 16px 20px;
}

/* Alineado con el título, a la derecha del ícono del menú. */
.subtitulo {
  margin: 0 0 0 40px;
  font-size: 12px;
}

.drawer {
  width: unset;
  z-index: 0;
  position: fixed;
  height: 100%;
}
.logoDI {
  cursor: pointer;
}
/* responsive, form small screens, use 13px font size */
@media (max-width: 960px) {
  .drawer {
    position: inherit;
    height: initial;
  }

  .semiborder_1 {
    /* border-radius: 0px 0px 0px 0px !important; */
    height: initial;
  }
  /* .semiborder_2 {
    border-radius: 0px 0px 0px 0px !important;
  } */

  .list_selected {
    background-color: #7a2b00;
  }
}
</style>
